<template>
  <div class="header">
    <cl-svg-icon
      width="20"
      height="20"
      icon-class="page_back_white"
      class="back_page"
      @click.native="backPage"
    ></cl-svg-icon>
    <cl-avatar
      width="120"
      height="120"
      :round="true"
      class="mr29"
      :src="baseInfo.avatar"
    ></cl-avatar>
    <div>
      <div class="name">{{ baseInfo.name }}</div>
      <div class="info">
        <div>
          <div class="title">出生日期</div>
          <div class="value DINM">{{ baseInfo.birthday }}</div>
        </div>
        <div>
          <div class="title">性别</div>
          <div class="value">
            {{ baseInfo.sex == 1 ? "男" : baseInfo.sex == 2 ? "女" : "" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script >
export default {
  props: {
    baseInfo: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    backPage() {
      console.log(0);
      this.$router.go(-1);
    },
  },
};
</script>
  
<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 158px;
  background-image: url("~@/assets/images/cfa/training_bg.png");
  background-color: #081625;
  padding: 19px 65px;
  box-sizing: border-box;
  color: #fff;
  position: relative;
}
.back_page {
  position: absolute;
  left: 24px;
  top: 20px;
}
.name {
  font-size: 20px;
  margin-bottom: 12px;
}
.info {
  display: flex;
  > div {
    width: 175px;
  }
  .title {
    opacity: 0.4;
    font-size: 16px;
    margin-bottom: 12px;
  }
  .value {
    font-size: 16px;
  }
}
</style>